import { Action, createReducer, on } from "@ngrx/store";

import { VendorSupportedProductsActions } from "../actions/vendor-supported-products.actions";
import {
	SELF_KEY,
	VendorSupportedProductsEntry,
	VendorSupportedProductsState
} from "../models/vendor-supported-products-state";

const initialState: VendorSupportedProductsState = {
	loading: false,
	saving: false,
	byKey: {}
};

function keyFor(vendorId?: string): string {
	return vendorId ?? SELF_KEY;
}

function withEntry(
	state: VendorSupportedProductsState,
	vendorId: string | undefined,
	productIds: string[]
): VendorSupportedProductsState {
	const next: VendorSupportedProductsState = {
		...state,
		byKey: {
			...(state.byKey ?? {}),
			[keyFor(vendorId)]: { productIds, hasLoaded: true }
		}
	};
	delete next.error;
	return next;
}

function withoutKey(
	byKey: { [key: string]: VendorSupportedProductsEntry },
	key: string
): { [key: string]: VendorSupportedProductsEntry } {
	const copy = { ...byKey };
	delete copy[key];
	return copy;
}

const reducer = createReducer(
	initialState,
	on(VendorSupportedProductsActions.list.getApi, (state): VendorSupportedProductsState => ({
		...state,
		loading: true
	})),
	on(VendorSupportedProductsActions.list.getSuccess, (state, action): VendorSupportedProductsState => ({
		...withEntry(state, action.vendorId, action.productIds),
		loading: false
	})),
	on(VendorSupportedProductsActions.list.getFail, (state, action): VendorSupportedProductsState => ({
		...state,
		loading: false,
		error: action.error as unknown
	})),
	on(VendorSupportedProductsActions.list.invalidate, (state, action): VendorSupportedProductsState => ({
		...state,
		byKey: withoutKey(state.byKey ?? {}, keyFor(action.vendorId))
	})),
	on(VendorSupportedProductsActions.save.put, (state): VendorSupportedProductsState => ({
		...state,
		saving: true
	})),
	on(VendorSupportedProductsActions.save.putSuccess, (state, action): VendorSupportedProductsState => ({
		...withEntry(state, action.vendorId, action.productIds),
		saving: false
	})),
	on(VendorSupportedProductsActions.save.putFail, (state, action): VendorSupportedProductsState => ({
		...state,
		saving: false,
		error: action.error as unknown
	}))
);

export function vendorSupportedProductsReducer(
	state: VendorSupportedProductsState | undefined,
	action: Action
): VendorSupportedProductsState {
	return reducer(state, action);
}
